import React, { useState, useEffect } from "react";
import axios from "axios";
import CryptoJS from 'crypto-js';
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
const AddTesterForm = ({ setShowForm }) => {
  const teamsURL = process.env.REACT_APP_API_Team;
  const apiUrl = process.env.REACT_APP_API_Testers;
  const [first_name, setFirstName] = useState("");
  const [last_name, setLastName] = useState("");
  const [account_title, setAccountTitle] = useState("");
  const [bank_name, setBankName] = useState("");
  const [account_number, setAccountNumber] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [contact_number, setContactNumber] = useState("");
  const [gender, setGender] = useState("");
  const [team, setTeam] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  // const [encryptedText, setEncryptedText] = useState('');
  const [teams, setTeams] = useState([]);
  const [errors, setErrors] = useState({
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    contact_number: "",
    gender: "",
    team: "",
    confirmPassword: "",
    account_number:"",
    account_title:"",
    bank_name:"",
  });
  useEffect(() => {
    fetchTeams();
  }, []);
  // const encryptText = () => {
  //   const encrypted = CryptoJS.AES.encrypt(text, 'secret passphrase').toString();
  //   setEncryptedText(encrypted);
  // };
  // To encrypt the test
  // onChange={(e) => setEncryptedText(e.target.value)}
  // const decryptText = () => {
  //   const decrypted = CryptoJS.AES.decrypt(encryptedText, 'secret passphrase').toString(CryptoJS.enc.Utf8);
  //   setDecryptedText(decrypted);
  // };
  const fetchTeams = async () => {
    setLoading(true);
    try {
      const response = await axios.get(teamsURL);
      setTeams(response.data.body);
    } catch (error) {
      console.error("Error fetching teams:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleFirstNameChange = (e) => {
    setFirstName(e.target.value);
    if (errors.first_name) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        first_name: "",
      }));
    }
  };

  const handleLastNameChange = (e) => {
    setLastName(e.target.value);
    if (errors.last_name) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        last_name: "",
      }));
    }
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    if (errors.email) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        email: "",
      }));
    }
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    if (errors.password) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        password: "",
      }));
    }
  };

  const handleContactNumberChange = (e) => {
    setContactNumber(e.target.value);
    if (errors.contact_number) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        contact_number: "",
      }));
    }
  };

  const handleGenderChange = (value) => {
    setGender(value);
    if (errors.gender) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        gender: "",
      }));
    }
  };
  const handleAccountTitleChange = (e) => {
    setAccountTitle(e.target.value);
    if (errors.account_title) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        account_title: "",
      }));
    }
  };
  const handleAccountNumberChange = (e) => {
    setAccountNumber(e.target.value);
    if (errors.account_number) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        account_number: "",
      }));
    }
    if (e.target.value.trim().length >= 35) {
      setErrors((prevErrors) => ({
          ...prevErrors,
          account_number: `Account number must be of valid length`,
      }));
  }
     // if (!/^[\d-]+$/.test(value.trim())) {
      //   setErrors((prevErrors) => ({
      //       ...prevErrors,
      //       account_number: "Account number can only contain digits and dashes",
      //   }));
    // }
  };
  const handleBankNameChange = (e) => {
    setBankName(e.target.value);
    if (errors.bank_name) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        bank_name: "",
      }));
    }
    if (/^\d+$/.test(e.target.value.trim())) {
      setErrors((prevErrors) => ({
          ...prevErrors,
          bank_name: "Bank name cannot be only digits",
      }));
  }
 
  };

  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
  };

  const handleTeamChange = (e) => {
    setTeam(e.target.value);
    setErrors((prevErrors) => ({ ...prevErrors, team: "" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};

    if (!password.trim()) {
      newErrors.password = "Please enter Password";
    } else if (password.trim().length < 6) {
      newErrors.password = "Password must be at least 6 characters long";
    }

    const contactNumberRegex = /^(?:\+?92|0)\d{10}$/;
    if (!contact_number.trim()) {
      newErrors.contact_number = "Please enter Contact Number";
    } else if (!contactNumberRegex.test(contact_number.trim())) {
      newErrors.contact_number =
        "Please enter a valid contact number (e.g., +92331514193 or 03313423987)";
    }

    if (!first_name.trim()) {
      newErrors.first_name = "Please enter First Name";
    }
    if (!last_name.trim()) {
      newErrors.last_name = "Please enter Last Name";
    }
    if (!email.trim()) {
      newErrors.email = "Please enter Email";
    }
    if (!gender) {
      newErrors.gender = "Please select Gender";
    }
    if (!team) {
      newErrors.team = "Please select Team";
    }
    if (password.trim() !== confirmPassword.trim()) {
      newErrors.confirmPassword = "Passwords do not match";
    }
    if (!account_title.trim()) {
      newErrors.account_title = "Please enter Account Title";
    }
    if (!account_number.trim()) {
      newErrors.account_number = "Please enter Account Number";
    }
    if (!bank_name.trim()) {
      newErrors.bank_name = "Please enter Bank Name";
    }
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
      const selectedTeam = teams.find((t) => t.id == team);
      if (!selectedTeam) {
        throw new Error("Selected team not found.");
      }

      const team_id = selectedTeam.id;

      const response = await axios.post(apiUrl, {
        first_name,
        last_name,
        email,
        password,
        contact_number,
        gender,
        role_id: 3,
        team_id: team_id,
        account_title,
        account_number,
        bank_name
      });

      setShowForm(false);
    } catch (error) {
      console.error("Error adding tester:", error);
      setErrors({ general: "Failed to add tester" });
    }
  };

  return (
    <>
      <div className="flex justify-between items-center pt-10 mb-4 pl-10 pr-10">
        <h2 className="text-2xl font-bold">Add Tester</h2>
        <div className="flex items-center">
          <button
            onClick={() => setShowForm(false)}
            className="btn btn-xs sm:btn-sm md:btn-md lg:btn-md bg-[white] text-primaryColor ml-8"
          >
            Cancel
          </button>
        </div>
      </div>
      <form
        onSubmit={handleSubmit}
        className="ml-10 mr-10 pl-10 pt-10 pr-10 pb-10 bg-[#FFFFFF]"
      >
        <div className="flex flex-wrap -mx-4">
          <div className="w-full md:w-1/2 px-4 mb-4">
            <label className="form-control">
              <span className="label-text">First Name</span>
              <input
                type="text"
                placeholder="Enter First Name"
                className="input input-bordered"
                value={first_name}
                onChange={handleFirstNameChange}
              />
              {errors.first_name && (
                <p className="text-[red] text-xs mt-1">{errors.first_name}</p>
              )}
            </label>
          </div>

          <div className="w-full md:w-1/2 px-4 mb-4">
            <label className="form-control">
              <span className="label-text">Last Name</span>
              <input
                type="text"
                placeholder="Enter Last Name"
                className="input input-bordered"
                value={last_name}
                onChange={handleLastNameChange}
              />
              {errors.last_name && (
                <p className="text-[red] text-xs mt-1">{errors.last_name}</p>
              )}
            </label>
          </div>

          <div className="w-full md:w-1/2 px-4 mb-4">
            <label className="form-control">
              <span className="label-text">Email</span>
              <input
                type="email"
                placeholder="Enter Email"
                className="input input-bordered"
                value={email}
                onChange={handleEmailChange}
              />
              {errors.email && (
                <p className="text-[red] text-xs mt-1">{errors.email}</p>
              )}
            </label>
          </div>
          <div className="w-full md:w-1/2 px-4 mb-4">
            <label className="form-control">
              <span className="label-text">Contact Number</span>
              <input
                type="tel"
                placeholder="Enter Contact Number"
                className="input input-bordered"
                value={contact_number}
                onChange={handleContactNumberChange}
              />
              {errors.contact_number && (
                <p className="text-[red] text-xs mt-1">
                  {errors.contact_number}
                </p>
              )}
            </label>
          </div>
          <div className="w-full md:w-1/2 px-4 mb-4 relative">
            <label className="form-control relative">
              <span className="label-text">Password</span>
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Enter Password"
                className="input input-bordered"
                value={password}
                onChange={handlePasswordChange}
              />
              <div
                className="absolute inset-y-0  right-0 top-5  flex items-center pr-3 cursor-pointer"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? (
                  <AiOutlineEyeInvisible size={25} className="text-[gray]" />
                ) : (
                  <AiOutlineEye size={25} className="text-[gray]" />
                )}
              </div>
            </label>
            {errors.password && (
              <p className="text-[red] text-xs mt-1">{errors.password}</p>
            )}
          </div>
          <div className="w-full md:w-1/2 px-4 mb-4 relative">
            <label className="form-control relative">
              <span className="label-text">Confirm Password</span>
              <input
                type={showConfirmPassword ? "text" : "password"}
                placeholder="Confirm Password"
                className="input input-bordered"
                value={confirmPassword}
                onChange={handleConfirmPasswordChange}
              />
              <div
                className="absolute inset-y-0  right-0 top-5  flex items-center pr-3 cursor-pointer"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              >
                {showConfirmPassword ? (
                  <AiOutlineEyeInvisible size={25} className="text-[gray]" />
                ) : (
                  <AiOutlineEye size={25} className="text-[gray]" />
                )}
              </div>
            </label>
          </div>

          <div className="w-full md:w-1/2 px-4 mb-4">
            <label className="form-control">
              <span className="label-text">Select Team</span>
              <select
                className="select select-bordered"
                value={team}
                onChange={handleTeamChange}
              >
                <option value="">Select Team</option>
                {loading ? (
                  <option disabled>Loading...</option>
                ) : (
                  teams.map((team) => (
                    <option key={team.id} value={team.id}>
                      {team.name}
                    </option>
                  ))
                )}
              </select>
              {errors.team && (
                <p className="text-[red] text-xs mt-1">{errors.team}</p>
              )}
            </label>
          </div>
          <div className="w-full md:w-1/2 px-4 mb-4">
            <div className="form-control">
              <span className="label-text">Gender</span>
              <div className="flex items-center space-x-4">
                <label className="flex items-center">
                  <input
                    type="radio"
                    value="male"
                    checked={gender === "male"}
                    onChange={() => handleGenderChange("male")}
                  />
                  <span className="ml-2">Male</span>
                </label>
                <label className="flex items-center">
                  <input
                    type="radio"
                    value="female"
                    checked={gender === "female"}
                    onChange={() => handleGenderChange("female")}
                  />
                  <span className="ml-2">Female</span>
                </label>
              </div>
              {errors.gender && (
                <p className="text-[red] text-xs mt-1">{errors.gender}</p>
              )}
            </div>
          </div>
          <div className="w-full md:w-1/2 px-4 mb-4">
            <label className="form-control">
              <span className="label-text">Bank Name</span>
              <input
                type="text"
                placeholder="Enter Bank Name"
                className="input input-bordered"
                value={bank_name}
                onChange={handleBankNameChange}
              />
              {errors.bank_name && (
                <p className="text-[red] text-xs mt-1">{errors.bank_name}</p>
              )}
            </label>
          </div>
          <div className="w-full md:w-1/2 px-4 mb-4">
            <label className="form-control">
              <span className="label-text">Account title</span>
              <input
                type="text"
                placeholder="Enter your Account Title"
                className="input input-bordered"
                value={account_title}
                onChange={handleAccountTitleChange}
              />
              {errors.account_title && (
                <p className="text-[red] text-xs mt-1">{errors.account_title}</p>
              )}
            </label>
          </div>
          <div className="w-full md:w-1/2 px-4 mb-4">
            <label className="form-control">
              <span className="label-text">Account Number</span>
              <input
                type="text"
                placeholder="Enter your Account Number"
                className="input input-bordered"
                value={account_number}
                onChange={handleAccountNumberChange}
              />
              {errors.account_number && (
                <p className="text-[red] text-xs mt-1">{errors.account_number}</p>
              )}
            </label>
          </div>
        </div>

        {errors.general && (
          <p className="text-red-500 text-xs mt-1">{errors.general}</p>
        )}
        <div className="flex justify-end">
          <button
            type="submit"
            className="btn btn-xs sm:btn-sm md:btn-md lg:btn-md bg-primaryColor text-[white] ml-2"
          >
            Add Tester
          </button>
        </div>
      </form>
    </>
  );
};

export default AddTesterForm;
